<template>
    <div class="footer-th">
      <div class="foot-flex">
        <div class="bottom-logo">
          <img src="/static/images/HomeTH/logo.png">
        </div>
        <div class="bottom-bq">
          <p>版权所有：山东天弘化学有限公司</p>
          <p>鲁ICP备14001229号-1</p>
        </div>
      </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {}
        },
        methods: {},
        computed: {},
        components: {}
    }
</script>

<style scoped>
  .footer-th{
    background: #0441A0;
    padding: 20px 0px;
  }
  .foot-flex{
    display: flex;
    width: 1300px;
    margin: 0px auto;
    align-items: center;
    justify-content: space-between;
  }
  .bottom-logo img{
    opacity: 0.3;
  }
  .bottom-bq p{
    font-size: 14px;
    color: #fff;
    opacity: 0.3;
    text-align: right;
  }
</style>



// WEBPACK FOOTER //
// src/components/FooterB/FooterB.vue